import React, {useState} from 'react';
import { IconButton } from "rsuite";
import { Funnel } from '@rsuite/icons';
import Form from 'react-bootstrap/Form';
import { post } from '../../utils/API';
import { API_URL } from '../../utils/API';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { sqlActions } from '../../Redux/sql';
import { useEffect } from 'react';
import Select from 'react-select';
import './Filter.css'
import { Button, Input} from 'rsuite';
import Switch from "react-switch";


export default function Filter({setMetadatas, setRendering, sql}) {
    const sqlInfo = useSelector((state) => state.sql)
    const dispatch = useDispatch()
    const [options, setColumnHeaders] = useState([])
    const [columnTypes, setColumnTypes] = useState(null)
    const [group, setGroup] = useState("")
    

    function onFilterChange(e) {
        dispatch(sqlActions.updateFilter(e.target.value))
    }

    function onKeyPressHandler(e) {
        if (e.key === "Enter") {
            getMetadatas()
        }
    }

    async function getMetadatas() {
        if (sqlInfo.tableName === "") {
            return 
        }

        try {
            setRendering(true)
            let response = await post(`${API_URL}/get-metadata`, {...sqlInfo, group: group, columnTypes: columnTypes})
            setMetadatas(response)
        } catch {
            setRendering(false)
            toast.error(<p>Oppsie! Something went wrong!</p>)
        }
      }

    function addNewFilter() {
        dispatch(sqlActions.updateFilterModel([...sqlInfo.filterModel, {id: Date.now(), column: "", operator: "", values: "", combine: false}]))
    }

    function removeFilter(id) {
        dispatch(sqlActions.updateFilterModel(sqlInfo.filterModel.filter((filter) => filter.id !== id)))
    }

    useEffect(() => {
        const getColumnHeaders = async () => {
            let response = await post(`${API_URL}/get-columns`, sqlInfo)
            let columnHeaders = response.columnHeaders.map((columnHeader) => {
                return {label: columnHeader, value: columnHeader}
            })
            setColumnHeaders(columnHeaders)
            setColumnTypes(response.columnTypes)
        }
        if (sql === false) {
          getColumnHeaders()
        }
    }, [sql])


    function updateFilterColumn(e, filter) {
        dispatch(sqlActions.updateFilterModel(sqlInfo.filterModel.map((currentFilter) => {
            if (currentFilter.id === filter.id) {
                return {...currentFilter, column: e.value}
            }
            return currentFilter
        })))
    }

    function updateFilterOperator(e, filter) {
        dispatch(sqlActions.updateFilterModel((sqlInfo.filterModel.map((currentFilter) => {
            if (currentFilter.id === filter.id) {
                return {...currentFilter, operator: e.value}
            }
            return currentFilter
        }))))
    }

    function updateFilterValue(e, filter) {
        dispatch(sqlActions.updateFilterModel((sqlInfo.filterModel.map((currentFilter) => {
            if (currentFilter.id === filter.id) {
                return {...currentFilter, values: e}
            }
            return currentFilter
        }))))
    }
    const switch_options = [
        {
            label: <span>Foo</span>,
            value: {
                 foo: true
            },
            selectedBackgroundColor: "#0097e6",
        },
        {
            label: "Bar",
            value: "bar",
            selectedBackgroundColor: "#fbc531"
        }
     ];

     const onChange = (newValue) => {
        console.log(newValue);
    };
    
    const initialSelectedIndex = options.findIndex(({value}) => value === "bar");

    function handleCheck(filter) {
        dispatch(sqlActions.updateFilterModel(sqlInfo.filterModel.map((currentFilter) => {
            if (currentFilter.id === filter.id) {
                if (currentFilter.combine) {
                    return {...currentFilter, combine: false}
                } else {
                    return {...currentFilter, combine: true}
                }
               
            }
            return currentFilter
        })))
    }

    function clearFilters() {

    }

    function handleLimitChange(e) {
        if (e === "") {
            dispatch(sqlActions.updateLimit(0))
            return
        }

        var limit
        try {
            limit = parseInt(e)
        } catch {return}
        

        if (limit > 5000) {
            dispatch(sqlActions.updateLimit(5000))
            return
        } 
        dispatch(sqlActions.updateLimit(limit))
    }

    function handleOffsetChange(e) {
        if (e === "") {
            dispatch(sqlActions.updateOffset(0))
            return
        }

        var offset
        try {
            offset = parseInt(e)
        } catch {return}
        dispatch(sqlActions.updateOffset(offset))
    }

    useEffect(() => {
        console.log(sqlInfo.filterModel)
    })

//<Form.Control type="text" placeholder="where id = 1" onChange={(e) => onFilterChange(e)} onKeyPress={(e)=> onKeyPressHandler(e)} value={sqlInfo.filter}/>
    return (
        <div className="filter-container p-1">
            <ToastContainer/>

            <div className='container-fluid'>
                <div className='row mt-1 mb-1'>
                    <div className='col-12 text-center'>
                        <h3>SELECT * FROM {sqlInfo.tableName}</h3>
                    </div>
                </div>
            
            {sqlInfo.filterModel.map(filter => {
                return   (
                    <div>
                    {!filter.first && 
                        <div className="row justify-content-center align-items-center">
                        <div className='col-3'>AND</div>
                    <div className='col-4'>
                

<Switch
checked={filter.combine}
onChange={() => handleCheck(filter)}
offColor="#90EE90" //light green
offHandleColor='#4CBB17' //lime green
onColor="#86d3ff" //#86d3ff
onHandleColor="#2693e6"
handleDiameter={30}
uncheckedIcon={false}
checkedIcon={false}
boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
height={20}
width={48}
className="react-switch"
id="material-switch"
/></div>
<div className='col-3'>OR</div>

                    </div>
    


                    }
                  
                <div className="row mt-1 mb-1">
              
                        <div className='col-4'>
                        <Select
  
                            value={{label: filter.column, value: filter.column}}
                            onChange={(e) => updateFilterColumn(e, filter)}
                            options={options}/>
                        </div>
                        <div className='col-3'>
              <Select

                value={{label: filter.operator, value: filter.operator}}
                onChange={(e ) => updateFilterOperator(e, filter)}
                options={[
                    {label: "=", value: "="}, 
                    {label: "!=", value: "!="},
                    {label: "<", value: "<"},
                    {label: ">", value: ">"},
                    {label: "<=", value: "<="},
                    {label: ">=", value: ">="}
                    ]}
      />
              </div>
                        <div className='col-3'>
                            <Input placeholder="Value" onChange={(e) => updateFilterValue(e, filter)} value={filter.values}/>
                        </div>
               
                        <div className='col-2'>
                        {!filter.first && 
                            <div className='delete-filter-icon' onClick={() => removeFilter(filter.id)}>
                                <img src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png" alt="" width={25} height={25}/>
                            </div>
                        }
                            
                            
                            {/** <button onClick={() => removeFilter(filter.id)}>Remove</button>*/}
                        </div>
                    </div>
          
                    </div>)
     
            })}
            <div className='row mt-1 mb-1'>
                <div className='col-12'>
                    <p>LIMIT</p>
                    <Input placeholder="Value" onChange={(e) => handleLimitChange(e)} value={sqlInfo.limit}/>
                </div>
                <div className='col-12'>
                    <p>OFFSET</p>
                    <Input placeholder="Value" onChange={(e) => handleOffsetChange(e)} value={sqlInfo.offset}/>
                </div>
                <div className='col-12'>
                    <p>GROUP BY</p>
                    <Select
                    value={{label: group, value: group}}
                    onChange={(e) => setGroup(e.value)}
                    options={options}/>
                </div>
               
            </div>
            <Button color="blue" onClick={() => addNewFilter()} className="m-2">Add <img src="https://img.icons8.com/ios/512/plus-2-math.png" alt="" width={30} height={30}/></Button>
            <Button onClick={() => dispatch(sqlActions.clearFilters())} className="m-2">Clear <img src="https://img.icons8.com/plasticine/512/clear-symbol.png" alt="" width={30} height={30}/></Button>

         
     
            <div className='row text-center'>
                <div className='col-5'></div>
                <div className='col-2'>
                    <IconButton icon={<Funnel/>} placement="left" onClick={() => getMetadatas()}>Filter</IconButton>
                </div>
                <div className='col-5'></div>
                
            </div>
       
        </div>

        </div>
    )
}